<template><div><h1>VUX V2.9.4 发布日志</h1>
<h2><a href="/zh-CN/components/picker.html">Picker</a></h2>
<ul><li>[fix] 修复多级联动模式下，快速滚动多个项，取值不正确</li>
</ul>
<h2><a href="/zh-CN/components/tab.html">Tab</a></h2>
<ul><li>[change] 修复 tab的父级width没有100%或者有padding 滚动造成文字跟横杠错位问题 #2850</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.9.4 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.9.4-271.vue?8b1cd976